<template>
  <article class="group__level-wrapper">
    <Level
      v-for="level in preparedLevels"
      :key="`level-${level.uuid}`"
      :level="level"
      :progress="progress"
      :levelMedia="preparedMedia"
    />
  </article>
</template>

<script>
import { mapState } from 'vuex'
import Level from '@/components/course/content/Level.vue'

export default {
  name: 'Levels',
  components: {
    Level,
  },
  props: {
    leaves: {
      type: Array,
      required: true,
    },
    progress: {
      type: [Object, String],
      required: false,
    },
  },
  data: () => {
    return {
      preparedLevels: [],
      preparedMedia: {},
    }
  },
  computed: {
    ...mapState({
      currentLevels: state => state.courses.currentLevels,
    }),
  },
  methods: {
    prepareLevels() {
      const levels = []
      const media = {}
      for (let index = 0; index < this.leaves.length; index++) {
        const leaf = this.leaves[index]
        const { content_type: type } = leaf
        if (type === 'video') {
          // A logical level is defined by a video
          if (!this.currentLevels.includes(leaf)) {
            this.$store.dispatch('courses/updateCurrentLevels', leaf)
          }
          levels.push(leaf)
          media[leaf.uuid] = {
            quiz: [],
            exercise: [],
          }
        } else if (type === 'lab') {
          if (!this.currentLevels.includes(leaf)) {
            this.$store.dispatch('courses/updateCurrentLevels', leaf)
          }
          levels.push(leaf)
        } else if (type === 'iframe') {
          if (!this.currentLevels.includes(leaf)) {
            this.$store.dispatch('courses/updateCurrentLevels', leaf)
          }
          levels.push(leaf)
        } else {
          media[levels[levels.length - 1].uuid][type].push(leaf)
        }
      }
      this.preparedLevels = levels
      this.preparedMedia = media
    },
  },
  mounted() {
    this.prepareLevels()
  },
}
</script>
